export default __webpack_public_path__ + "static/media/portrait4.e68a816a.JPG";